import React from 'react';

const Attributes: React.FC = () => {
  return (
    <div>
      <h1>Attributes</h1>
      <p>This is the Attributes component.</p>
    </div>
  );
};

export default Attributes;
